<template>
  <div>
    <ul class="nav nav-tabs">
      <li class="nav-item">	    
	<RouterLink class="nav-link px-2 px-sm-3"  :class="activeClass('overview')" :to="{ name: 'Construction' }">Overview</RouterLink>
      </li>
      <!--li class="nav-item">
	<RouterLink class="nav-link px-2 px-sm-3" :to="{ name: 'Trinity-PDF' }" :class="activeClass('pdf')">Trinity PDF&trade;</RouterLink>
      </li-->
      <li class="nav-item">
	<RouterLink class="nav-link px-2 px-sm-3" :to="{ name: 'Trinity-PDF' }" :class="activeClass('pdf')">Trinity Crosslink&trade;</RouterLink>
      </li>
      <li class="nav-item">
	<RouterLink class="nav-link px-2 px-sm-3" :to="{ name: 'Trinity-Meta' }" :class="activeClass('meta')">Trinity Meta&trade;</RouterLink>
      </li>
      <li class="nav-item">
	<RouterLink class="nav-link px-2 px-sm-3" :to="{ name: 'Trinity-Link' }" :class="activeClass('link')">Trinity Link&trade;</RouterLink>
      </li>
    </ul>
  </div>
</template>

<script>
const $ = require('jquery')
import * as log from 'loglevel'
export default {
    name: 'ProductsTab',
    props: {
	activeProductTab: String
    },
    methods: {
	activeClass: function (tab) {
	    if (this.activeProductTab === tab) {
		return 'active'
	    }
	}
    }
}
</script>

<style>
.nav-link.active {
    color: #ff0000 !important;
    font-weight: 700;
}
.nav-link {
    color: #595959 !important;
    font-size: 1.25em;
}
@media (max-width: 576px) {
    .nav-link {
	font-size: 0.85em;
    }
}
</style>
